import { useEffect } from "react";
import { Typography } from "@dealer-center/core-components";

export const PagesNrtDatabaseFilterToolUi = () => {
  useEffect(() => {
    document.title = "NRT Mapping Tool";
  }, []);
  return (
    <Typography sx={{ margin: "1rem" }} variant="h2">
      NRT Mapping Tool
    </Typography>
  );
};
